import { PHONE_NO_LENGTH } from "./Constants";
import * as Yup from "yup";


export const PHONE_VALIDATION= Yup.string()
.test('phone_required', 'Phone number is required', (value) => {
        const phoneNumber = (value && value.length ? value.split(" ")[1]:"");
        return phoneNumber && phoneNumber.length;
    }
  )
.test('phone_digit_error', 'Phone number must only contain digits', (value) => {
        const phoneNumber = (value && value.length ? value.split(" ")[1]:"");
        return phoneNumber && /^\d+$/.test(phoneNumber);
    }
  )
.test('phone_min_length', 'Phone number minimum length is {{PHONE_MIN_LENGTH}}', (value) => {
        const phoneNumber = (value && value.length ? value.split(" ")[1]:"");
        return phoneNumber && phoneNumber.length >= PHONE_NO_LENGTH.min;
    }
  )
.test('phone_max_length', 'Phone number maximum length is {{PHONE_MAX_LENGTH}}', (value) => {
        const phoneNumber = (value && value.length ? value.split(" ")[1]:"");
        return phoneNumber && phoneNumber.length <= PHONE_NO_LENGTH.max;
    }
  );